import { useNavigate } from 'react-router';
import { Button } from 'react-aria-components';
import { NavigateRoutesEnum } from '@features/routing/routesEnum';
import { AppPage } from 'components/app-page/AppPage';



interface NoPermissionProps {
	requiredRoles: string | string[],
}


export const NoPermission = (props: NoPermissionProps) => {
	const { requiredRoles } = props;

	const navigate = useNavigate();

	const requiredRolesText =
		Array.isArray(requiredRoles)
		? requiredRoles.join()
		: typeof requiredRoles === 'string' && requiredRoles.length > 0
		? requiredRoles
		: 'role neuvedena'

	return (
		<AppPage
			className='base-page no-permission-page'
			pageLabel='Pro přístup k této stránce nemáte oprávnění'
			showToolbar={false}
		>
			<h1>Pro přístup k této stránce nemáte oprávnění</h1>

			<p>Pro zobrazení stránky je nutné mít jednu z rolí:</p>

			<p className='required-roles'>{requiredRolesText}</p>

			<Button
				className='app-highlight-button btn'
				onPress={() => navigate(NavigateRoutesEnum.basePath)}>
					Zpět na hlavní stranu
			</Button>
		
		</AppPage>
	)
};